import React from 'react';
import { Link } from 'react-router-dom';
import Services from '../../api/Services';
import Bg from '@images/services/service-bg.webp'
import { LanguageContext } from '../../index';
import { useContext } from 'react';

const ServiceSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const { language } = useContext(LanguageContext);

    return (
        <section className={`services-section rpt-100 pb-70 ${props.ptClass}`} style={{ backgroundImage: `url(${Bg})` }}>
            <div className="container">
                <div className="row">
                    {Services[language].slice(0, 3).map((service, Sitem) => (
                        <div className="col-lg-4 col-md-6 col-12" key={Sitem}>
                            <div className="service-item">
                                <span className="number">{service.Id}</span>
                                <img src={service.sImg} alt="Icon" />
                                <h3><Link onClick={ClickHandler} to={`/${language === "en" ? "service-single" : "usluga"}/${service.slug}`}>{service.sTitle}</Link></h3>
                                <p>{service.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}


export default ServiceSection;